export default "__VITE_ASSET__DiZ4I6XR__"